import { render, staticRenderFns } from "./management-question-view.vue?vue&type=template&id=5a225b21&scoped=true&"
import script from "./management-question-view.vue?vue&type=script&lang=js&"
export * from "./management-question-view.vue?vue&type=script&lang=js&"
import style0 from "./management-question-view.vue?vue&type=style&index=0&id=5a225b21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a225b21",
  null
  
)

export default component.exports